import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVertexAdd = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 3L11.15 5.45L12.2 10.7L8.7 14.2L3.45 13.15L1 3ZM1 3L6.3102 8.3102M8 14.9L12.9 10L15 12.1L10.1 17L8 14.9ZM8.7 9.3C8.7 10.0732 8.0732 10.7 7.3 10.7C6.5268 10.7 5.9 10.0732 5.9 9.3C5.9 8.5268 6.5268 7.9 7.3 7.9C8.0732 7.9 8.7 8.5268 8.7 9.3Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5714 2.57143V0H14.4286V2.57143H17V3.42857H14.4286V6H13.5714V3.42857H11V2.57143H13.5714Z",
			fill: "currentColor"
		})
	]
});
export default SvgVertexAdd;
